import script from "./FranchiseDayHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseDayHeader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import FranchiseMerchantSwitcher from "@/components/franchise/FranchiseMerchantSwitcher.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
script.components = Object.assign({}, { FranchiseMerchantSwitcher, SecondaryTop }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { FranchiseMerchantSwitcher, SecondaryTop }, script.__o.components);}